export const EMAIL = 'info@nestbuilder.co';
export const PHONE_NUMBER = '+1 307 416 0051';

export const WEBSITE = 'https://nestbuilder.co';
export const PRIVACY_EMAIL = 'privacy@nestbuilder.co';
export const DATA_SUBJECT_ACCESS_REQUEST_FORM = 'https://app.termly.io/notify/28ceafff-a3d6-43af-a967-fd5f2f6cdd67';

export const MAP_ADDRESS = 'https://maps.app.goo.gl/kyGEfv1kcE5bTdoG8';
